import styled from 'styled-components'
import { Button } from '@navent-jobs/ui-kit/components/button'

export const MainPage = styled('div')`
  margin-top: -56px;

  @media (min-width: ${({ theme }) => theme.screen.lgMin}) {
    margin-top: -76px;
  }

  @media (min-width: 1024px) {
    margin-top: 0px;
  }
`

export const StickyContainerHeader = styled.div`
  position: sticky;
  background-color: ${({ theme }) => theme.colors['body-bg']};
  top: ${({ top }) => `${top}px` || '183px'};
  z-index: 16;

  @media (min-width: 1024px) and (max-width: 1200px) {
    top: ${({ top }) => `${top - 48}px` || '185px'};
  }
`

export const StickyContainerWrapper = styled.div`
  position: sticky;
  top: ${({ top }) => top || '183px'};
  z-index: 15;

  @media (min-width: 992px) and (max-width: 1024px) {
    top: 48px;
  }
`

export const StickyContainer = styled.div`
  position: sticky;
  top: ${({ top }) => top || '205px'};
  z-index: 15;

  @media (min-width: 1024px) and (max-width: 1200px) {
    top: 158px;
  }
`

export const StickyContainerFooter = styled.div`
  position: sticky;
  bottom: 0px;
  z-index: 20;
  width: 100%;
`

export const NavWrapper = styled('div')`
  width: 100%;
  height: 48px;
  background-color: white;
  padding: 11px 9px 11px 18px;
  position: sticky;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  z-index: 10;
`

export const ButtonBack = styled(Button)`
  width: 24px;
  height: 24px;
  cursor: pointer;

  i:before,
  &:hover > i:before,
  &:active > i:before,
  &:focus:not(:active) > i:before {
    color: ${({ theme }) => theme.colors.grey84} !important;
    background-color: ${({ theme }) => theme.colors.grey84} !important;
  }
`

export const AnchorBarBackground = styled.div`
  position: absolute;
  width: calc(100% - 16px);
  z-index: -1;
  height: 36px;
  top: -30px;
  background-color: ${({ theme }) => theme.colors['body-bg']};
`
